export default [
  {
    path: "/ai/translate",
    name: "ai-translate",
    component: () => import(
      /*webpackChunkName:'ai'*/
      "@/views/ai/Translate.vue"),
    meta: {},
  },
  {
    path: "/ai/exploit",
    name: "ai-exploit",
    component: () => import(
      /*webpackChunkName:'ai'*/
      "@/views/ai/Exploit.vue"),
    meta: {},
  },
  {
    path: "/ai/chat-bot",
    name: "chat-bot",
    component: () => import(
      /*webpackChunkName:'ai'*/
      "@/views/ai/ChatBot.vue"),
    meta: {},
  },
  {
    path: "/ai/report",
    name: "report",
    component: () => import(
      /*webpackChunkName:'ai'*/
      "@/views/ai/Report.vue"),
    meta: {},
  },
  {
    path: "/exploit",
    name: "exploit",
    component: () => import(
      /*webpackChunkName:'exploit'*/
      "@/views/exploit/ExploitList.vue"),
    meta: {},
  },
  {
    path: "/attack/profile",
    name: "attackProfileList",
    component: () => import(
      /*webpackChunkName:'attack'*/
      "@/views/attack/AttackProfileList.vue"),
    meta: {},
  },
  {
    path: "/attack/poc",
    name: "attackPoc",
    component: () => import(
      /*webpackChunkName:'attack'*/
      "@/views/attack/PocList.vue"),
    meta: {},
  },
  {
    path: "/integration/metasploit",
    name: "testProject",
    component: () => import(
      /*webpackChunkName:'metasploit'*/
      "@/views/attack/MetasploitList.vue"),
    meta: {},
  },
  {
    path: "/cve/poc",
    name: "CvePoc",
    component: () => import(
      /*webpackChunkName:'poc'*/
      "@/views/cvepoc/CvePocList.vue"),
    meta: {},
  },
]